import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusDetailsComponent } from './components/bus-details/bus-details.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { BusDetailsMoreComponent } from './modals/bus-details-more/bus-details-more.component';

@NgModule({
  declarations: [
    BusDetailsComponent,
    BusDetailsMoreComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,  // REQUIRED
    MatDialogModule       
  ]
})
export class SharedModule { }
